export const Drag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g>
                <path fill="currentColor" d="M6 8h12v2H6V8Zm0 6h12v2H6v-2Z"/>
            </g>
        </svg>
    );
};